import React from 'react';
import PropTypes from 'prop-types';
import css from './WaitingRoom.scss';
import { throttle } from 'lodash';
import {getWaitingTime, shouldDisplayWaitTime} from "../../../utils/waitingRoom";

export default class WaitingRoom extends React.Component {

  constructor() {
    super();
    this.state = { width: window.innerWidth };

    // Reference: https://stackoverflow.com/questions/38564080/remove-event-listener-on-unmount-react
    this.onResize = throttle(this.onResize.bind(this), 1000);
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
  }

  onResize() {
    this.setState({width: window.innerWidth});
  }

  shouldDisplay() {
    const { kioskQueueSize, kioskMaxWaitTime, kioskType } = this.props;
    return shouldDisplayWaitTime(kioskQueueSize, kioskMaxWaitTime, kioskType);
  }

  get waitingRoomText() {
    const { kioskQueueSize, kioskMaxWaitTime } = this.props;

    // No time given, simply return how many in line
    if ( kioskMaxWaitTime === 0 ) return `${kioskQueueSize} in line`;

    const { minutes, hours, days } = getWaitingTime(kioskMaxWaitTime);
    const daysText = `${days > 0 ? (days + 'd ') : ''}`;
    const hoursText = `${hours > 0 ? (hours + 'h ') : ''}`;
    const minutesText = `${minutes > 0 ? (minutes + 'm') : ''}`;
    return `${kioskQueueSize} in line, ${daysText}${hoursText}${minutesText} wait`;
  }

  get waitingRoomLink() {
    // if they are a service member of any service, go to the services > waiting room panel
    if (this.props.isServiceMember) {
      return <a style={{width: this.width}} href={"../instructor/serviceCatalog.html?activeTab=waitingRoom"}>
        {this.waitingRoomText}
      </a>
    } else if (this.props.displayStudentQueue) {
      // if student queue should be displayed, go to student view of waiting room
      return <a style={{width: this.width}} href={"../kiosk/waitingRoom.html?kioskId=" + this.props.kioskId}>
        {this.waitingRoomText}
      </a>
    } else {
      return this.waitingRoomText;
    }
  }

  get width() {
    return this.state.width <= 340 && this.props.compact ? "100px" : "auto";
  }

  render() {
    if ( !this.shouldDisplay() ) return null;
    return <div className={css['waiting']} style={{width: this.width}}>{this.waitingRoomLink}</div>;
  }
}

WaitingRoom.propTypes = {
  compact: PropTypes.bool,
  kioskQueueSize: PropTypes.number,
  kioskMaxWaitTime: PropTypes.number,
  kioskId: PropTypes.number,
  displayStudentQueue: PropTypes.bool,
  isServiceMember: PropTypes.bool.isRequired,
  kioskType: PropTypes.string
};
